module.exports = __webpack_public_path__ + "media/images/flags/1x1/bwa-8f83f7dc93b14e6bb59ce6dbff33d51d.svg";